import { motion } from "framer-motion";
import { ShieldCheck, Cpu, BadgeEuro } from "lucide-react";
import { Chapter } from "@/components/landing/Chapter";

const IMG =
  "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Expertise multimarque",
    desc: "Toutes marques, tous modèles : essence, diesel, hybride. Votre garantie constructeur est préservée.",
  },
  {
    icon: Cpu,
    title: "Diagnostic de pointe",
    desc: "Valises diagnostic multimarques dernière génération pour une recherche de panne précise et rapide.",
  },
  {
    icon: BadgeEuro,
    title: "Transparence totale",
    desc: "Devis gratuit et détaillé avant chaque intervention. Aucune réparation sans votre accord.",
  },
];

export const Presentation = () => (
  <section id="garage" data-testid="presentation-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Chapter num="01" title="Le garage" accent="Présentation & savoir-faire" />

      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-5"
        >
          <p className="text-base md:text-lg text-slate-300 leading-relaxed">
            Installé au <strong className="text-white">56 Avenue d'Oyonnax à Bellignat</strong>,
            AUTO MECA PRO — enseigne <strong className="text-white">AMP Services 01</strong> —
            est votre atelier de proximité pour l'entretien et la réparation de véhicules légers.
          </p>
          <p className="mt-5 text-base text-slate-400 leading-relaxed">
            Mécanique générale, pneumatiques, freinage, climatisation, mais aussi vente de véhicules
            neufs et d'occasion, pièces détachées et remplacement de pare-brise : une équipe
            de professionnels à votre service, six jours sur sept.
          </p>

          <div className="mt-12 space-y-8">
            {VALUES.map((v, i) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="flex gap-5 group"
              >
                <div className="shrink-0 w-11 h-11 rounded-sm border border-white/10 bg-[#0E1322] flex items-center justify-center transition-colors duration-300 group-hover:border-[#0066FF]/60 group-hover:bg-[#0066FF]/10">
                  <v.icon className="w-5 h-5 text-[#00E5FF]" />
                </div>
                <div>
                  <h3 className="font-display font-bold text-lg">{v.title}</h3>
                  <p className="text-sm text-slate-400 mt-1 leading-relaxed">{v.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7 relative"
        >
          <div className="absolute -inset-4 bg-[#0066FF]/10 blur-3xl rounded-full pointer-events-none" />
          <div
            className="relative overflow-hidden border border-white/10"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 48px), calc(100% - 48px) 100%, 0 100%)" }}
          >
            <img
              src={IMG}
              alt="Diagnostic électronique automobile dans l'atelier AMP Services 01"
              className="w-full h-[420px] lg:h-[560px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07090E]/85 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-4">
              <div>
                <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#00E5FF]">Atelier</div>
                <div className="font-display font-bold text-xl mt-1">Bellignat — Ain (01)</div>
              </div>
              <span className="rounded-full border border-[#0066FF]/50 bg-[#0066FF]/15 backdrop-blur px-4 py-1.5 text-xs font-semibold text-white whitespace-nowrap">
                Devis gratuit
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
